import { useState, useEffect } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export const useMediaKit = () => {
  const [kit, setKit] = useState(null);
  useEffect(() => {
    fetch(`${API}/api/media`).then((r) => r.json()).then(setKit).catch(() => setKit({ bios: {}, gallery: [], headshots: [], one_sheet_url: "" }));
  }, []);
  return kit;
};

export const isOwnFile = (url) => url?.startsWith("/api/files/");
export const downloadHref = (url) => (isOwnFile(url) ? `${url}?download=1` : url);
